import { Text, View } from '@react-pdf/renderer'
import { Style } from '@react-pdf/types'
import React from 'react'
import { getPdfTableHeaderStyle, pdfTableColStyle, PdfTableHeaderConfig } from './PdfTableStyles'

interface PdfTableHeaderCellProps {
  headerConfig?: PdfTableHeaderConfig
  style?: Style | Style[]
  children?: React.ReactNode
}

/**
 * Header cell of a PDF table, keeps the header labels of all table form elements styled the same.
 * Place it in a {@link PdfUnsplittableTableRow}, as the content of header is always known.
 */
export const PdfTableHeaderCell = ({
  headerConfig,
  style = [],
  children
}: PdfTableHeaderCellProps): React.ReactElement => (
  <View
    style={[
      pdfTableColStyle,
      getPdfTableHeaderStyle(headerConfig),
      ...(Array.isArray(style) ? style : [style])
    ]}
  >
    <Text>{children ?? ' '}</Text>
  </View>
)
